import { DateTime } from "luxon"
import { IUserFormattingSettings } from "../../components/applicationheader/components/usermenu"

export const parseUserInputForUsTime = (newValue: string): string => {
    const a = DateTime.fromFormat(newValue, "h:mm a")
    return a.toFormat("HH:mm")
}

export const parseOdataDateValue = (value: string, format: string): string => {
    let parsedDate
    if (format === "ISO") {
        parsedDate = DateTime.fromISO(value, {
            setZone: true,
        })
    } else {
        parsedDate = DateTime.fromFormat(value, format, { setZone: true })
    }
    if (!parsedDate.isValid) {
        return ""
    }
    return parsedDate.toISO() ?? ""
}

export const getFormatBasedOnType = (type: string): string => {
    switch (type) {
        case "#TF.DateItemField":
            return "yyyy-MM-dd"
        case "#TF.TimeItemField":
            return "HH:mm:ss'.'u"
        case "#TF.DateTimeOffsetItemField":
        default:
            return "ISO"
    }
}

export const formatDateTimeStringFromISO = (
    dateString: string,
    userFormattingSettings?: IUserFormattingSettings,
): string | undefined => {
    if (!dateString) {
        return ""
    }
    const date = DateTime.fromISO(dateString)
    if (!date.isValid) {
        return undefined
    }
    return date.toFormat(
        `${userFormattingSettings?.shortDatePattern || "dd/MM/yyyy"} ${
            userFormattingSettings?.shortTimeFormat || "HH:mm"
        }`,
    )
}

export const convertStringToDateTime = (
    dateString: string,
): DateTime | undefined => {
    if (!dateString) {
        return undefined
    }
    const date = DateTime.fromISO(dateString)
    if (!date.isValid) {
        return undefined
    }
    return date
}
